import { FilterDescriptor, CompositeFilterDescriptor } from "@progress/kendo-data-query";
import { ConditionalLogicExpression } from "./conditional-logic-expression.model";

export class ActionIdAndName {
    public constructor (public id: number, public actionName: string)
    {
    }
}

export const availableActions: ActionIdAndName[] =
    [
            new ActionIdAndName(0, 'Hide'),
            new ActionIdAndName(1, 'Show'),
            new ActionIdAndName(2, 'Edit'),
            new ActionIdAndName(3, 'Require'),
    ];

export class RuleWithAction {
    public constructor(public ruleName: string, public action: string)
    {
        //this.actionId = availableActions.find(aa => aa.actionName == action).id;
        const actionIdAndName: ActionIdAndName = availableActions.find(aa => aa.actionName == action);
        if (actionIdAndName != null) {
            this.actionId = actionIdAndName.id;
        } else {
            console.log(`RuleWithAction:  could not find an ActionIdAndName for action '${action}'`);
        }
    }

    public id: number = 0; // The rule's assigned Id value in the database or zero if no value has been assigned.
    public actionId: number = 1; // Corresponds to 'Show'
    public actionChanged(selectedValue: number): void {
       this.action = availableActions.find(aa => aa.id == selectedValue).actionName;
    }

    //public logicOperator: 'or' | 'and' = 'and';
    public isActive: boolean;

    //public filters: Array<FilterDescriptor | CompositeFilterDescriptor> = [];
    public filterValue: CompositeFilterDescriptor = {
        logic: 'and',
        filters: []
    };
}

export class AssociatedRuleWithAction {
    public id: number = 0; // The id of the saved rule-to-target field association, if it has been saved, or zero.

    ruleWithAction: RuleWithAction = null;
    ruleOrder: number = 0;

    public constructor(ruleWithActionParam: RuleWithAction, ruleOrderParam: number = 0) {
        this.ruleWithAction = ruleWithActionParam;
        this.ruleOrder = ruleOrderParam;
    }
}

export class RulesSummaryEntry {
    public targetFieldId: number;
    public targetFieldDisplayName: string;
    public targetFieldInternalName: string;
    public ruleName: string;
    public ruleAndOr: string;
    public ruleOrder: number;
    public ruleAction: string;
    public sourceFieldDisplayName: string;
    public sourceFieldInternalName: string;
    public ruleOperator: string;
    public ruleConditionValue: string;
    public cssClass: string;
}
